import { render, staticRenderFns } from "./Fullanswer.vue?vue&type=template&id=2a4fa9c6&"
import script from "./Fullanswer.vue?vue&type=script&lang=js&"
export * from "./Fullanswer.vue?vue&type=script&lang=js&"
import style0 from "./Fullanswer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports